// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/login/Login";
import RegisterUser from "./components/register/RegisterUser";
import AdminPanel from "./components/admin/AdminPanel";
import ProtectedRoute from "./components/ProtectedRoute";
import CrearPregunta from "./components/admin/CrearPregunta";
import NivelesUsuario from "./components/usuario/NivelesUsuario";
import NivelesPreguntas from "./components/admin/NivelesPreguntas";
import ListaUsuarios from "./components/admin/ListaUsuarios";
import ResultadoUsuario from "./components/usuario/ResultadoUsuario";
import UsuarioDashboard from "./components/usuario/UsuarioDashboard";
import PreguntasRespuestas from "./components/usuario/PreguntasRespuestas";
import ContenidoMultimedia from "./components/usuario/ContenidoMultimedia";
import TrofeoUsuario from "./components/usuario/TrofeoUsuario";
import SessionManager from "./hooks/SessionManager";
import PreguntasRespuestasFinal from "./components/usuario/PreguntasRespuestasFinal";

import TemasNivel from "./components/admin/TemasNivel";
import TemasPorNivel from "./components/usuario/TemasPorNivel";
import EvaluacionFinal from "./components/admin/EvaluacionFinal";
import RevisionNivel from "./components/usuario/RevisionNivel";
import EditarPregunta from "./components/admin/EditarPregunta";

import VideoTutorialAdmin from "./components/admin/VideoTutorialAdmin";
import TutorialAyuda from "./components/usuario/TutorialAyuda";

// ✅ Definimos los grupos de roles una sola vez
const ROLES_DOCENTE = ["Docente", "Docente de planta", "Docente de cátedra"];
const ROLES_ADMIN = ["Administrador"];
const ROLES_USUARIO = [
  "Estudiante",
  "Administrativo",
  ...ROLES_DOCENTE,
  ...ROLES_ADMIN,
];

function App() {
  return (
    <SessionManager>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/register"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <RegisterUser />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin-panel"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <AdminPanel />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/crear-pregunta"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <CrearPregunta />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/editar-pregunta/:id"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <EditarPregunta />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/niveles-preguntas"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <NivelesPreguntas />
            </ProtectedRoute>
          }
        />

        {/* Ruta para listar los temas de un nivel */}
        <Route
          path="/admin/temas/:nivelId"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <TemasNivel />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/tema/:temaId"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <TemasNivel />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/evaluacion/:evaluacionId"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <EvaluacionFinal />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/lista-usuarios"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <ListaUsuarios />
            </ProtectedRoute>
          }
        />

        {/* Resto de rutas de usuario/estudiante */}
        <Route
          path="/user-dashboard"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <UsuarioDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/niveles"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <NivelesUsuario />
            </ProtectedRoute>
          }
        />
        <Route
          path="/resultados"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <ResultadoUsuario />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trofeo-usuario"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <TrofeoUsuario />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tema/multimedia/:temaId"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <ContenidoMultimedia />
            </ProtectedRoute>
          }
        />
        <Route
          path="/tema/quiz/:tema"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <PreguntasRespuestas />
            </ProtectedRoute>
          }
        />
        <Route
          path="/quizzes/tema/:tema"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <TemasPorNivel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/evaluacion-final/nivel/:nivelId"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <PreguntasRespuestasFinal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/temas/nivel/:nivelId"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <RevisionNivel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/video-tutorial"
          element={
            <ProtectedRoute allowedRoles={ROLES_ADMIN}>
              <VideoTutorialAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ayuda"
          element={
            <ProtectedRoute allowedRoles={ROLES_USUARIO}>
              <TutorialAyuda />
            </ProtectedRoute>
          }
        />

        {/* Cualquier otra ruta redirige al login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SessionManager>
  );
}

export default App;
